export default "__VITE_ASSET__V5rNwEcw__"